/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { ClientFormSection } from '../components/ClientDetailView/client-quality';

/** The sections a link is allowed to open the edit form onto. */
const EDITABLE_SECTIONS: readonly ClientFormSection[] = [
  'personal', 'contacts', 'identity', 'personalExtra',
  'address', 'financial', 'preferences',
];

/**
 * Reads the `?edit=` parameter as a form section.
 *
 * Anything that is not one of the known sections is discarded rather than
 * passed through: the value reaches the drawer as a DOM selector and as a
 * key on its expansion state, and a typo would silently open nothing.
 *
 * @param raw - The raw query-parameter value, or null when absent.
 * @returns The section to open onto, or undefined.
 */
export function readEditSectionParam(raw: string | null): ClientFormSection | undefined {
  const match = EDITABLE_SECTIONS.find((section) => section === raw);
  return match;
}
